import React from 'react'
import { NormalizedCacheObject } from 'apollo-cache-inmemory'
import ApolloClient from 'apollo-client'
import {
  GetDocumentListSettingsDocument,
  GetInitialUserDocument,
} from 'gqlTypes'
import { createApolloClient } from 'graphql/apolloClient'
import { setFallbackAuthorizationId } from 'graphql/multisession'
import { createStoragePersist } from 'graphql/utils'
import { ApolloProvider as ApolloProviderOriginal } from 'react-apollo'

/**
 * TODO: research whether it would be safe to remove global ApolloClient reference and
 * use React's `useRef` and/or `useEffect` hooks.
 *
 * Particularly see how the app would behave if ApolloProvider would be unmounted,
 * an error would be catched by higher `ErrorBoundary` and similar edge cases.
 */
let globallyCacheApolloClient:
  | ApolloClient<NormalizedCacheObject>
  | undefined = undefined

const getClient = () => {
  if (globallyCacheApolloClient) {
    return globallyCacheApolloClient
  }

  const apolloClient = createApolloClient()

  // GraphQL Queries synced with local-storage
  const storagePersist = createStoragePersist(apolloClient)

  storagePersist.syncQueryWithStorage(GetInitialUserDocument, 'userProfile')
  storagePersist.syncQueryWithStorage(
    GetDocumentListSettingsDocument,
    'documentLayout'
  )

  setFallbackAuthorizationId(apolloClient.cache)

  globallyCacheApolloClient = apolloClient
  return globallyCacheApolloClient
}

export const ApolloProvider: React.FC = ({ children }) => {
  const client = getClient()
  return (
    <ApolloProviderOriginal client={client}>{children}</ApolloProviderOriginal>
  )
}
